/**
 * 查看详情
 * 2017-12-27
 * by 于再洋
 */
"use strict";
angular.module("helpModule", []).
controller("helpCtrl", ["$scope", '$modalInstance', 'trsHttpService', "$document","$timeout", function($scope, $modalInstance, trsHttpService, $document,$timeout) {
	initStatus();
    initData();
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {};
        $scope.data = {};
    }
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {
        var params = {
             "typeid": 'screen',
             "serviceid": 'zjSentimentCommonMgr',
             "modelid": 'help',
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            $scope.helpdata = data;
        });
    }

    /**
     * [cancel description] 取消
     * @return {[type]} [description]
     */
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };

}]);